import isFunction from 'lodash/isFunction';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/takeUntil';
import {AbstractEpics} from '../redux/AbstractEpics';
import {epicErrorHandler} from '../rx-utils';

/**
 * Exported for unit testing
 */
export class ReduxRequestEpics extends AbstractEpics {
  /**
   * @param {ReduxRequestActions} actions
   * @param {ReduxRequestOptions} options
   */
  constructor(actions, options) {
    super(options);

    /** @type {ReduxRequestActions} **/
    this.actions = actions;
    /** @param {ReduxRequestOptions} */
    this.options = options;

    this.getRequestState = isFunction(options.getRequestState) ? options.getRequestState : options.getState;

    this.requestFactory = this.options.requestFactory;

    this.onSendRequest = this.onSendRequest.bind(this);
    this.addEpic(this.onSendRequest);

    if (options.autoReset > 0) {
      this.onResetRequest = this.onResetRequest.bind(this);
      this.addEpic(this.onResetRequest);
    }
  }

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   */
  onSendRequest(action$, store) {
    const resetActions = this.getResetActions();

    return action$.ofType(this.actions.sendRequest.TYPE)
      .switchMap(action => {
        const rootState = store.getState();
        const state = this.getRequestState(rootState);
        const request = this.options.buildRequest(state, action.payload);

        return this.requestFactory.sendRequest(request, rootState)
          .map(ajaxResponse => {
            const status = this.options.getResponseStatus(request, ajaxResponse);
            return this.actions.requestSuccess({status, request, ajaxResponse});
          })
          .catch(err => Observable.of(this.actions.requestError({err})))
          .takeUntil(action$.ofType(...resetActions));
      })
      .catch(epicErrorHandler(this.logger, 'ReduxRequestEpics.onSendRequest'));
  }

  /**
   * Reset the request state after a specified delay unless another request is sent.
   * @param {ActionsObservable<ReduxAction>} action$
   */
  onResetRequest(action$) {
    const resetActions = this.getResetActions();

    return action$.ofType(this.actions.requestSuccess.TYPE, this.actions.requestError.TYPE)
      .switchMap(() =>
        Observable
          .timer(this.options.autoReset)
          .take(1)
          .mapTo(this.actions.resetRequest())
          .takeUntil(action$.ofType(this.actions.sendRequest.TYPE, ...resetActions))
      )
      .catch(epicErrorHandler(this.logger, 'ReduxRequestEpics.onResetRequest'));
  }

  getResetActions() {
    return [
      this.actions.resetRequest,
      ...(this.options.resetActions || []),
    ].map(action => action.TYPE);
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-request/epics.js